import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import {
  FaCss3,
  FaEnvelope,
  FaFigma,
  FaHtml5,
  FaJs,
  FaMapMarkerAlt,
  FaNodeJs,
  FaPhoneAlt,
  FaReact,
} from "react-icons/fa";
import { SiAngular, SiNextdotjs, SiShadcnui, SiTailwindcss } from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb";
import { ReactElement } from "react";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

interface AboutInfo {
  fildName: string;
  fildValue: string;
}

export const about: {
  title: string;
  description: string;
  info: AboutInfo[];
} = {
  title: "About me",
  description:
    "A passionate front-end developer based in Surat, India, with a love for building fast, accessible, and visually stunning web experiences.",
  info: [
    {
      fildName: "Name",
      fildValue: "Parth Kalani",
    },
    {
      fildName: "Phone",
      fildValue: "+91 7383339901",
    },
    {
      fildName: "Experience",
      fildValue: "5+ Years",
    },
    {
      fildName: "Nationality",
      fildValue: "Indian",
    },
    {
      fildName: "Email",
      fildValue: "parthkalani9282@gmail.com",
    },
    {
      fildName: "Freelance",
      fildValue: "Available",
    },
    {
      fildName: "Languages",
      fildValue: "English,Hindi,Gujarati",
    },
  ],
};

interface ExperienceItem {
  company: string;
  position: string;
  duration: string;
}

export const experience: {
  icon: string;
  title: string;
  description: string;
  items: ExperienceItem[];
} = {
  icon: "/assets/resume/badge.svg",
  title: "My Exeperience",
  description:
    "Over 5 years of professional experience building scalable web applications and leading front-end development across startups and enterprises.",
  items: [
    {
      company: "Neoverce IT Solutions",
      position: "Front-End Developer Intern",
      duration: "2021 - 2022",
    },
    {
      company: "Neoverce IT Solutions",
      position: "Front-End Native Developer",
      duration: "2022 - 2024",
    },
    {
      company: "Softera AI",
      position: "Next Js Developer",
      duration: "OCT-2025",
    },
  ],
};

interface EducationItem {
  institution: string;
  degree: string;
  duration: string;
}

export const education: {
  icon: string;
  title: string;
  description: string;
  items: EducationItem[];
} = {
  icon: "/assets/resume/badge.svg",
  title: "My Exeperience",
  description:
    "A solid academic foundation in engineering that fueled a deep interest in software development and modern web technologies.",
  items: [
    {
      institution: "Sri Bhagawan Mahaveer Jain College",
      degree: "Bachelor of Engineering (BEng),",
      duration: "2027 - 22",
    },
  ],
};

interface SkillItem {
  icon: ReactElement;
  degree: string;
}

export const skill: {
  title: string;
  description: string;
  skillList: SkillItem[];
} = {
  title: "My skills",
  description:
    "A versatile skill set spanning modern front-end frameworks, UI tooling, and design — built through years of hands-on project work.",
  skillList: [
    {
      icon: <FaHtml5 />,
      degree: "html 5",
    },
    {
      icon: <FaCss3 />,
      degree: "css 3",
    },
    {
      icon: <FaJs />,
      degree: "javaScript",
    },
    {
      icon: <FaReact />,
      degree: "react.js",
    },
    {
      icon: <SiNextdotjs />,
      degree: "next.js",
    },
    {
      icon: <SiTailwindcss />,
      degree: "tailwind.css",
    },
    {
      icon: <FaNodeJs />,
      degree: "node.js",
    },
    {
      icon: <FaFigma />,
      degree: "figma",
    },
    {
      icon: <TbBrandReactNative />,
      degree: "react native",
    },
    {
      icon: <SiAngular />,
      degree: "angular",
    },
    {
      icon: <SiShadcnui />,
      degree: "shadcn/ui",
    },
  ],
};

interface ServiceData {
  num: string;
  title: string;
  description: string;
  href: string;
}

export const servicesData: ServiceData[] = [
  {
    num: "01",
    title: "TRADEICS",
    description:
      "Tradeics is a cloud-based Procure‑to‑Pay (P2P) and B2B sales platform designed to modernize and streamline both procurement and business-to-business selling processes for enterprises. Tradeics targets medium to large enterprises looking to scale their procurement and B2B sales operations via automated, secure, and analytics‑driven digital workflows",
    href: "https://tradeics.com/en",
  },
  {
    num: "02",
    title: "RR GROUP HOTELS",
    description:
      "Surat takes the hassle out of travelling. Enjoy a change of pace when you stay in our pristine hotel. Get a blissful night's sleep after an eventful day, thanks to our luxury bedding",
    href: "https://www.rrgrouphotels.com/",
  },
  {
    num: "03",
    title: "Nj Capital",
    description:
      "based on data sciences, has caused a fundamental transformation in the experience of the retail borrower. NJ Capital Private Limited (NJC) marks the entry of NJ group into digital lending.",
    href: "https://www.njcapital.in/",
  },
  {
    num: "04",
    title: "Yoloh Online-Insurance Site",
    description:
      "is a digital platform that offers one-stop insurance services. Get insurance at your own convenience through our secure platform without having the need of multiple interactions.",
    href: "https://agent-dev.yoloh.net/",
  },
  {
    num: "05",
    title: "MT-Hood E-Shopping Website",
    description:
      "is one of the largest ski resorts in Oregon and the largest ski resort on Mount Hood. It is located about 67 miles east of Portland, and 35 miles from Hood River along Oregon Route 35. It has both Alpine and Nordic ski areas and offers night skiing, lessons and equipment rentals. In the summer Meadows offers scenic chair rides, a premier hiking experience on Mt. Hood and events on the weekends.",
    href: "https://development.skihood.com/",
  },
  {
    num: "06",
    title: "Storiz.eu",
    description:
      "The new platform for selling and buying second-hand products in video stories.",
    href: "https://apps.apple.com/us/app/storiz-eu/id1667887738/",
  },
];

interface ContactInfo {
  icon: ReactElement;
  title: string;
  description: string;
}

export const contactInfo: ContactInfo[] = [
  {
    icon: <FaPhoneAlt />,
    title: "",
    description: "+91 7383339901",
  },
  {
    icon: <FaEnvelope />,
    title: "",
    description: "parthkalani9282@gmail.com",
  },
  {
    icon: <FaMapMarkerAlt />,
    title: "",
    description: "Surat Gujarat India",
  },
];
